function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
BulkTemplateWizardModalController.$inject = ["$element", "$logFactory", "$sce", "$scope"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
/* injects from baggage-loader */
require('./bulk-template-wizard-modal.component.html');
import angular from 'angular';
import { ChildMessagePort } from '../../utilities/messaging';
import { getUrlComponents } from '../../utilities/url';
import "./bulk-template-wizard-modal.component.scss";
angular.module('AaApp.Opp').component('bulkTemplateWizardModal', {
  templateUrl: '/app/components/modals/bulk-template-wizard-modal.component.html',
  controller: BulkTemplateWizardModalController,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
});
function BulkTemplateWizardModalController($element, $logFactory, $sce, $scope) {
  "ngInject";

  var $ctrl = this;
  var $log = $logFactory.get('bulkTemplateWizard');
  $ctrl.$onInit = $onInit;
  var PASSTHROUGH_MESSAGE_TYPES = ["SEARCH_PARAMETERS_REQ"];
  $ctrl.buttons = {
    "BACK": {
      translationKey: 'back',
      onClick: onButtonClicked.bind(null, "BACK")
    },
    "NEXT": {
      translationKey: 'next',
      onClick: onButtonClicked.bind(null, "NEXT")
    },
    "CLOSE": {
      translationKey: 'close',
      onClick: onButtonClicked.bind(null, "CLOSE")
    },
    "CANCEL": {
      translationKey: 'cancel',
      onClick: onButtonClicked.bind(null, "CANCEL")
    },
    "SEND_EMAIL": {
      translationKey: 'sendEmail',
      onClick: onButtonClicked.bind(null, "SEND_EMAIL")
    },
    "ARCHIVE_PDF": {
      translationKey: 'archivePdfAndClose',
      onClick: onButtonClicked.bind(null, "ARCHIVE_PDF")
    },
    "PRINT_PDF": {
      translationKey: 'printToPdf',
      onClick: onButtonClicked.bind(null, "PRINT_PDF")
    }
  };
  function $onInit() {
    $ctrl.title = $ctrl.resolve.title;
    $ctrl.trustedUrl = $sce.trustAsResourceUrl($ctrl.resolve.src);
    var _getUrlComponents = getUrlComponents($ctrl.resolve.src),
      origin = _getUrlComponents.origin;
    if ($ctrl.resolve.onRendered) {
      $ctrl.resolve.onRendered.promise.then(function () {
        var iframe = $element.find('iframe')[0];
        $ctrl.port = new ChildMessagePort(iframe, origin, $scope);
        $ctrl.port.message$.subscribe(messageHandler);
        $ctrl.$onDestroy = function () {
          $ctrl.port.close();
        };
      });
    }
  }
  function onButtonClicked(button) {
    $ctrl.port.postMessage({
      type: "DIALOG_BUTTON_CLICKED",
      data: {
        button: button
      }
    });
  }
  function getSearchGridMessagePort() {
    return $ctrl.resolve.searchGridMessagePort;
  }
  function messageHandler(message) {
    if (PASSTHROUGH_MESSAGE_TYPES.includes(message.type)) {
      var port = getSearchGridMessagePort();
      var replyPort = message.replyPort;
      var forwardedMessage = {
        type: message.type,
        data: message.data
      };
      port.postRequest(forwardedMessage).then(function (reply) {
        $log.log("forwarding", reply);
        replyPort.postMessage({
          type: reply.type,
          data: reply.data
        });
      });
    } else {
      switch (message.type) {
        case "DIALOG_TITLE":
          {
            var text = message.data.text;
            $log.debug("changing title", text);
            $ctrl.title = text;
            break;
          }
        case "DIALOG_BUTTON_CONFIGURE":
          {
            var _message$data = message.data,
              button = _message$data.button,
              state = _message$data.state;
            $log.debug("changing buttons", button, state);
            setButtonStateFromText(button, state);
            break;
          }
        case "DIALOG_BUTTON_CLICK":
          {
            var _button = message.data.button;
            $log.debug("clicking button", _button);
            onButtonClicked(_button);
            break;
          }
        case "DIALOG_CLOSE":
          {
            $log.debug("closing dialog");
            $ctrl.close();
            break;
          }
        case "ALL_DIALOG_BUTTON_LOCK_UNLOCK":
          {
            allButtonLockUnlock();
            break;
          }
        default:
          $log.debug("Unhandled message type", message);
      }
    }
  }
  function allButtonLockUnlock() {
    $ctrl.buttons.CANCEL.disabled = !$ctrl.buttons.CANCEL.disabled;
    $ctrl.buttons.ARCHIVE_PDF.disabled = !$ctrl.buttons.ARCHIVE_PDF.disabled;
    $ctrl.buttons.PRINT_PDF.disabled = !$ctrl.buttons.PRINT_PDF.disabled;
    $ctrl.buttons.SEND_EMAIL.disabled = !$ctrl.buttons.SEND_EMAIL.disabled;
  }
  function setButtonStateFromText(button, stateName) {
    var currentState = $ctrl.buttons[button];
    $ctrl.buttons[button] = getState(currentState, stateName);
    function getState(currentState, newStateName) {
      switch (newStateName.toUpperCase()) {
        case "VISIBLE":
          return _objectSpread(_objectSpread({}, currentState), {}, {
            visible: true
          });
        case "HIDDEN":
          return _objectSpread(_objectSpread({}, currentState), {}, {
            visible: false
          });
        case "ENABLED":
          return _objectSpread(_objectSpread({}, currentState), {}, {
            visible: true,
            disabled: false
          });
        case "DISABLED":
          return _objectSpread(_objectSpread({}, currentState), {}, {
            visible: true,
            disabled: true
          });
      }
    }
  }
}